import { useDepartments } from '@/shared/hooks/useDepartments'

interface DepartmentsPickerProps {
  value: string[]
  onChange: (next: string[]) => void
  disabled?: boolean
}

// Multi-select of the organization's departments. A project's departments
// decide which department admins can see it (members always can).
export function DepartmentsPicker({ value, onChange, disabled }: DepartmentsPickerProps) {
  const { data: departments = [] } = useDepartments()

  // Keep any saved name selectable even if that department was since removed.
  const names = Array.from(new Set([...departments.map((d) => d.name), ...value]))

  const toggle = (name: string) =>
    onChange(value.includes(name) ? value.filter((n) => n !== name) : [...value, name])

  if (names.length === 0) {
    return <p className="text-xs text-muted-foreground">No departments available.</p>
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {names.map((name) => {
        const selected = value.includes(name)
        return (
          <button
            key={name}
            type="button"
            disabled={disabled}
            aria-pressed={selected}
            onClick={() => toggle(name)}
            className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors disabled:opacity-50 ${
              selected
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-muted-foreground border-border hover:bg-muted hover:text-foreground'
            }`}
          >
            {name}
          </button>
        )
      })}
    </div>
  )
}
